export enum CdnHosts {
    retailcrm = 's3-s1.retailcrm.tech',
    simla = 's3-o1.retailcrm.tech'
}
